import { useParams } from "wouter";
import { useGangContext } from "./useGang.ts";

export function useGit() {
  const { gang, readOnly } = useGangContext();
  const { gitId } = useParams<{ gitId: string }>();
  const lookup = gang.getGit(gitId);
  const git = lookup.valueOrNull();
  return { git, lookup, readOnly };
}
